// --------------------------------------------------------
// CANCEL MODAL - CancelModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Modal from '@mui/material/Modal'
import React, { useState } from 'react'
import { GenericSolidButton, RedCancelButton } from '../UI/buttons/Button.styled'
import { H1, H2, H3, Text } from '../UI/generalLayout/Layout.styled'
import { ReactComponent as Exclamation } from '../../assets/imgs/exclamation.svg'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { ButtonAreaContainer, ModalContainer, ModalContentContainer } from './RegistrarJustificativaModal.styled'
import Colors from '../../constants/Colors'
import { useAppDispatch } from '../..';
import { IconButton, Radio } from '@mui/material'
import * as acessoProntuario from '../../store/actions/acessoProntuario';
import { PersonService } from '../../core/http/service/PersonService'
import { useLocation, useNavigate } from 'react-router-dom';
import { Paths } from '../../enums/Paths'
import { atualizaAcessoProntuario } from '../../store/actions/person'

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CANCEL MODAL INTERFACE
// --------------------------------------------------------

interface IRegistrarJustificativaModal {
    visible: boolean;
    profissionalId: string;
    pacienteId: string;
    onClose: any;
}
/**
/**
 * A component that renders a Cancel modal.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const RegistrarJustificativaModal = ({ visible, profissionalId, pacienteId, onClose }: IRegistrarJustificativaModal) => {
    // --------------------------------------------------------
    // CANCEL MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo(); 
    const dispatch = useAppDispatch();
    const [modalTitle, setModalTitle] = useState("Selecione uma justificativa para pode acessar a tela de prontuário");
    const [erro, setErro] = useState<any>(null);  
    const [selectedOption, setSelectedOption] = useState(null);
    const navigate = useNavigate();
    const options = [
        { id: 'Monitoramento', text: 'Obtenção de dados para ação interna de monitoramento' },
        { id: 'Informacoes', text: 'Informação a pedido do colaborador e/ou dependente' },
      ];
    
      const handleRadioChange = (optionId: any) => {
        
        setSelectedOption((prevSelected) => (prevSelected === optionId ? null : optionId));
      };            

    const RegistrarJustificativa = async ()=>{

        try {

            if(selectedOption){
                setErro("")
                await dispatch(acessoProntuario.registrarJustificativa(profissionalId, pacienteId, selectedOption)); 
                await navigateToProntuario(pacienteId);           
            }else{
                setErro("Nenhuma descrição foi selecionada")
            }
                
        } catch (error) {
            console.log(error)            
        }

    }

    const navigateToProntuario = async (pacienteId: string) => {

        const service: PersonService = new PersonService();        
        try {
            const result: any = await service.getPessoaById(pacienteId);

            dispatch(atualizaAcessoProntuario(true));
            
            if(result.status == 200){
                var pessoaAtual = result.data.data;
                navigate(Paths.Prontuario, { state: { pessoa: pessoaAtual } });
            }

        } catch (error: any) {
            console.log(error);
        }

    }

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Modal
                open={visible}
                
            >
  
                <ModalContainer isMobile={isMobile}>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={onClose}
                    aria-label="fechar"
                    style={{ position: 'absolute', right: 15, top: 5 }}
                    >
                    x
                </IconButton>
                    <ModalContentContainer isMobile={isMobile}>
                        {isMobile? <H2>{modalTitle}</H2> : <H1>{modalTitle}</H1> }<br/> 
                        <>
                        <div style={{ 
                            display: 'flex',
                            flexWrap: 'wrap', 
                            gap: '10px',
                            justifyContent: 'center' 
                        }}>
                            {
                                options.map((option) => (
                                    <div 
                                        key={option.id} 
                                        style={{ 
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            width: '500px'
                                        }}
                                    >
                                        <Radio
                                            checked={selectedOption === option.id}
                                            onChange={() => handleRadioChange(option.id)}
                                            value={option.id}
                                        />
                                        <label>{option.text}</label>
                                    </div>
                                ))
                            }
                        </div>

                        </>                        
                        <br/>                 
                        <ButtonAreaContainer>
                            <GenericSolidButton
                                style={{ marginTop: isMobile? 12 : 0 }}
                                color={Colors.SPM600}
                                onClick={RegistrarJustificativa}
                            >
                                Registrar Justificativa
                            </GenericSolidButton>
                        </ButtonAreaContainer>
                        <>
                        {
                            erro? 
                                (<span style={{ color: "red" }}>{erro}</span>)
                            :
                                ''
                        }
                        </>
                    </ModalContentContainer>
                </ModalContainer>
            </Modal>
        </>
    )
    // --------------------------------------------------------
}

export default RegistrarJustificativaModal